import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibraryComponent } from '../All-LibraryComponents';
import { GoogleMapsModule } from '@angular/google-maps';
import { ZORRO_MODULES } from './zorro-modules';
import { BaseSharedModule } from 'base-shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { StatusColorPipe } from './pipes';
@NgModule({
  declarations: [...LibraryComponent, StatusColorPipe],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    GoogleMapsModule,
    BaseSharedModule,
    TranslateModule.forChild(),
    RecaptchaFormsModule,
    ...ZORRO_MODULES,
  ],

  exports: [...LibraryComponent, StatusColorPipe],
})
export class SharedModule {}
